








































































































































import { PaymentMethod, PaymentMethodText } from "@/models/order/helpers";
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { Validations } from "vuelidate-property-decorators";
import { required } from "vuelidate/lib/validators";
import FormValidation from "@/components/elements/form/FormValidation.vue";
import { EventBus } from "@/event-bus";

@Component({
  components: {
    FormValidation
  }
})
export default class Payment extends Vue {
  protected PaymentMethod = PaymentMethod;
  protected PaymentMethodText = PaymentMethodText;
  protected methodModel = PaymentMethod.FullPrepay;
  @Prop() card!: string;
  @Prop() method!: PaymentMethod;
  @Prop() auth!: boolean;
  @Validations()
  validations() {
    return {
      method: { required }
      //   card: {
      //     cardReq: (value) => {
      //       if (!value && this.method === PaymentMethod.CreditCard) {
      //         return false;
      //       } else {
      //         return true;
      //       }
      //     },
      //   },
    };
  }
  @Watch("$v.$invalid", { deep: true })
  onFormChange(): void {
    this.validateForm();
  }
  @Watch("method", { immediate: true })
  updateMethodModel(): void {
    this.methodModel = this.method;
  }

  created() {
    EventBus.$on("submitCheckoutForm", this.validateForm);
  }

  beforeDestroy() {
    EventBus.$off("submitCheckoutForm");
  }

  protected validateForm(): void {
    this.$v.$touch();
    this.$emit("sendError", this.$v.$invalid, "payment");
  }

  /**
   * Have to explicitly call vuelidate ($v) methods if not using v-model
   */
  public updateItem(fieldValue: string, fieldName: string) {
    this.$emit(`update:${fieldName}`, fieldValue);
    if (this.$v[fieldName]) {
      this.$v[fieldName]!.$touch();
      this.validateForm();
    }
  }
}
